import React from "react";

{/* <svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 20 20 60v80c0 50 80 80 80 80s80-30 80-80V60Z" fill="#1a2236" stroke="#4a5568" stroke-width="4"/>
  <circle cx="100" cy="120" r="50" fill="none" stroke="#4a5568" stroke-width="4"/>
  <path d="m100 75 2.1 7h7l-5.6 4.2 2.1 7L100 89l-5.6 4.2 2.1-7-5.6-4.2h7ZM75 85l2.1 7h7l-5.6 4.2 2.1 7L75 99l-5.6 4.2 2.1-7-5.6-4.2h7Zm-10 23 2.1 7h7l-5.6 4.2 2.1 7L65 122l-5.6 4.2 2.1-7-5.6-4.2h7Zm10 27 2.1 7h7l-5.6 4.2 2.1 7L75 149l-5.6 4.2 2.1-7-5.6-4.2h7Zm25 10 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm25-10 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm10-27 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm-10-23 2.1 7h7l-5.6 4.2 2.1 7L125 99l-5.6 4.2 2.1-7-5.6-4.2h7Z" fill="#4a5568"/>
</svg> */}

// const GDPRshield = ({ shieldColor = "#1a2236", accentColor = "#4a5568" }) => {
//   return (
//     <svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg">
//       <path 
//         d="M100 20 20 60v80c0 50 80 80 80 80s80-30 80-80V60Z" 
//         fill={shieldColor} 
//         stroke={accentColor} 
//         strokeWidth="2"
//       />
//       <circle 
//         cx="100" 
//         cy="120" 
//         r="50" 
//         fill="none" 
//         stroke={accentColor} 
//         strokeWidth="2"
//       />
//       <path 
//         d="m100 75 2.1 7h7l-5.6 4.2 2.1 7L100 89l-5.6 4.2 2.1-7-5.6-4.2h7ZM75 85l2.1 7h7l-5.6 4.2 2.1 7L75 99l-5.6 4.2 2.1-7-5.6-4.2h7Zm-10 23 2.1 7h7l-5.6 4.2 2.1 7L65 122l-5.6 4.2 2.1-7-5.6-4.2h7Zm10 27 2.1 7h7l-5.6 4.2 2.1 7L75 149l-5.6 4.2 2.1-7-5.6-4.2h7Zm25 10 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm25-10 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm10-27 2.1 7h7l-5.6 4.2 2.1 7-5.6-4.2-5.6 4.2 2.1-7-5.6-4.2h7Zm-10-23 2.1 7h7l-5.6 4.2 2.1 7L125 99l-5.6 4.2 2.1-7-5.6-4.2h7Z" 
//         fill={accentColor}
//       />
//     </svg>
//   );
// };

// export default GDPRshield;

const GDPRshield = ({ 
  gradientStartColor = "#1a2236", 
  gradientEndColor = "#2a3246", 
  accentColor = "#4a55688c",
  style,
  width,
  height
}) => {
  const gradientId = "shieldGradient";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 518 646"
      style={style}
    >
      <path
        fill="url(#paint0_linear)"
        stroke={accentColor}
        strokeWidth="4"
        d="M258.4 2.381L2.19 130.93l.382 256.333C2.81 547.47 259.353 643.214 259.353 643.214S515.609 546.708 515.371 386.5l-.381-256.333L258.4 2.381z"
      />
      <path
        stroke={accentColor}
        strokeWidth="4"
        d="M259.115 483.006c88.503-.132 160.143-71.966 160.012-160.447-.132-88.48-71.985-160.101-160.489-159.97-88.503.132-160.143 71.966-160.011 160.447.132 88.48 71.984 160.101 160.488 159.97z"
      />
      <path
        fill={accentColor}
        d="M259 175l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L259 209.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L259 175zM323 193l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L323 227.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L323 193zM365 235l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L365 269.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L365 235zM385 294l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L385 328.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L385 294zM365 353l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L365 387.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L365 353zM323 403l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L323 437.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L323 403zM134 294l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L134 328.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L134 294zM149 235l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L149 269.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L149 235zM153 353l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L153 387.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L153 353zM195 403l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L195 437.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L195 403zM259 424l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L259 458.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L259 424zM195 193l5.613 17.275h18.163l-14.694 10.676 5.613 17.274L195 227.549l-14.695 10.676 5.613-17.274-14.694-10.676h18.163L195 193z"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="258.4"
          x2="259.353"
          y1="2.381"
          y2="643.214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStartColor} stopOpacity="0.7" />
          <stop offset="1" stopColor={gradientEndColor} stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GDPRshield;